import { createSlice } from '@reduxjs/toolkit'

const slice = createSlice({
    name: 'testimonialData',
    initialState: { testimonial_data: null },
    reducers: {
        updateTestimonialData: (state, { payload: { data } }) => {
            state.testimonial_data = data
        },
        clearTestimonialData: (state, { }) => {
            state.testimonial_data = null
        },
    },
})

export const { updateTestimonialData, clearTestimonialData } = slice.actions

export default slice.reducer
